// extracted by mini-css-extract-plugin
export default {"themeButton":"ToggleTheme_themeButton__6ecRB"};